/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AdminSubmission,
  AuthorBioResponse,
  AuthorMergeInput,
  AuthorMergePreview,
  AuthorNotabilityOverride,
  AuthorNotabilityReview,
  AuthorNotabilityReviewList,
  AuthorPairInput,
  AuthorProfileResponse,
  CreateFeedbackBody,
  CreateQuoteBody,
  EnrichmentBlastRadius,
  EnrichmentGovernanceSummary,
  EnrichmentPipelineStatus,
  EnrichmentWorkItemInput,
  EnrichmentWorkItemRequest,
  EntityCandidateDecision,
  EntityJobControl,
  EntityResolutionJob,
  EntityResolutionWorkspace,
  EntityScanInput,
  ErrorResponse,
  FavoriteToggleResponse,
  FeedbackItem,
  GetAuthorBioParams,
  GetAuthorNotabilityReviewsParams,
  GetCommunityQuotesParams,
  GetEntityResolutionParams,
  GetFeedbackItemsParams,
  GetPoorlyReceivedQuotesParams,
  GetPublicLibraryCount200,
  GetQuoteSimilarParams,
  GetQuotesParams,
  GetQuotesRecommendationsParams,
  HarvestStats,
  HealthStatus,
  MySubmissionsResponse,
  PaginatedCommunityQuotes,
  PaginatedQuotes,
  PinQuoteBody,
  PinnedQuote,
  PoorlyReceivedQuote,
  QuoteCluster,
  QuoteCurationInput,
  QuoteCurationPreview,
  QuoteCurationResult,
  QuoteCurationRetryInput,
  QuoteCurationWorkspace,
  QuoteResolutionCandidate,
  QuoteSubmission,
  QuoteWithTags,
  RecommendedQuote,
  RecomputeCentroids202,
  RequestUploadUrlBody,
  RequestUploadUrlResponse,
  SearchQuoteResolutionCandidatesParams,
  SubmitQuoteBody,
  SubmitQuoteResponse,
  SubmitRateLimitResponse,
  Tag,
  UpdateContentPreferencesBody,
  UpdateFeedbackBody,
  UpdateNotificationSettingsBody,
  UpdatePinnedQuotesResponse,
  UpdateProfileBody,
  UpdateQuoteStatusBody,
  UpdateSubmissionStatusBody,
  UserProfile,
  VoteQuoteBody,
  VoteQuoteResponse,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getGetEntityResolutionUrl = (
  params?: GetEntityResolutionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/entity-resolution?${stringifiedParams}`
    : `/api/admin/entity-resolution`;
};

export const getEntityResolution = async (
  params?: GetEntityResolutionParams,
  options?: RequestInit,
): Promise<EntityResolutionWorkspace> => {
  return customFetch<EntityResolutionWorkspace>(
    getGetEntityResolutionUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetEntityResolutionQueryKey = (
  params?: GetEntityResolutionParams,
) => {
  return [`/api/admin/entity-resolution`, ...(params ? [params] : [])] as const;
};

export const getGetEntityResolutionQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntityResolution>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEntityResolutionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEntityResolution>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEntityResolutionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEntityResolution>>
  > = ({ signal }) =>
    getEntityResolution(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntityResolution>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEntityResolutionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntityResolution>>
>;
export type GetEntityResolutionQueryError = ErrorType<unknown>;

export function useGetEntityResolution<
  TData = Awaited<ReturnType<typeof getEntityResolution>>,
  TError = ErrorType<unknown>,
>(
  params?: GetEntityResolutionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEntityResolution>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEntityResolutionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getStartEntityScanUrl = () => {
  return `/api/admin/entity-resolution/scans`;
};

export const startEntityScan = async (
  entityScanInput: EntityScanInput,
  options?: RequestInit,
): Promise<EntityResolutionJob> => {
  return customFetch<EntityResolutionJob>(getStartEntityScanUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(entityScanInput),
  });
};

export const getStartEntityScanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startEntityScan>>,
    TError,
    { data: BodyType<EntityScanInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startEntityScan>>,
  TError,
  { data: BodyType<EntityScanInput> },
  TContext
> => {
  const mutationKey = ["startEntityScan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startEntityScan>>,
    { data: BodyType<EntityScanInput> }
  > = (props) => {
    const { data } = props ?? {};

    return startEntityScan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartEntityScanMutationResult = NonNullable<
  Awaited<ReturnType<typeof startEntityScan>>
>;
export type StartEntityScanMutationBody = BodyType<EntityScanInput>;
export type StartEntityScanMutationError = ErrorType<unknown>;

export const useStartEntityScan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startEntityScan>>,
    TError,
    { data: BodyType<EntityScanInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startEntityScan>>,
  TError,
  { data: BodyType<EntityScanInput> },
  TContext
> => {
  return useMutation(getStartEntityScanMutationOptions(options));
};

export const getPreviewAuthorMergeUrl = () => {
  return `/api/admin/entity-resolution/author-preview`;
};

export const previewAuthorMerge = async (
  authorPairInput: AuthorPairInput,
  options?: RequestInit,
): Promise<AuthorMergePreview> => {
  return customFetch<AuthorMergePreview>(getPreviewAuthorMergeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(authorPairInput),
  });
};

export const getPreviewAuthorMergeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAuthorMerge>>,
    TError,
    { data: BodyType<AuthorPairInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewAuthorMerge>>,
  TError,
  { data: BodyType<AuthorPairInput> },
  TContext
> => {
  const mutationKey = ["previewAuthorMerge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewAuthorMerge>>,
    { data: BodyType<AuthorPairInput> }
  > = (props) => {
    const { data } = props ?? {};

    return previewAuthorMerge(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewAuthorMergeMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewAuthorMerge>>
>;
export type PreviewAuthorMergeMutationBody = BodyType<AuthorPairInput>;
export type PreviewAuthorMergeMutationError = ErrorType<unknown>;

export const usePreviewAuthorMerge = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAuthorMerge>>,
    TError,
    { data: BodyType<AuthorPairInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewAuthorMerge>>,
  TError,
  { data: BodyType<AuthorPairInput> },
  TContext
> => {
  return useMutation(getPreviewAuthorMergeMutationOptions(options));
};

export const getMergeAuthorsUrl = () => {
  return `/api/admin/entity-resolution/author-merge`;
};

export const mergeAuthors = async (
  authorMergeInput: AuthorMergeInput,
  options?: RequestInit,
): Promise<EntityResolutionJob> => {
  return customFetch<EntityResolutionJob>(getMergeAuthorsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(authorMergeInput),
  });
};

export const getMergeAuthorsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeAuthors>>,
    TError,
    { data: BodyType<AuthorMergeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mergeAuthors>>,
  TError,
  { data: BodyType<AuthorMergeInput> },
  TContext
> => {
  const mutationKey = ["mergeAuthors"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mergeAuthors>>,
    { data: BodyType<AuthorMergeInput> }
  > = (props) => {
    const { data } = props ?? {};

    return mergeAuthors(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MergeAuthorsMutationResult = NonNullable<
  Awaited<ReturnType<typeof mergeAuthors>>
>;
export type MergeAuthorsMutationBody = BodyType<AuthorMergeInput>;
export type MergeAuthorsMutationError = ErrorType<unknown>;

export const useMergeAuthors = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mergeAuthors>>,
    TError,
    { data: BodyType<AuthorMergeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof mergeAuthors>>,
  TError,
  { data: BodyType<AuthorMergeInput> },
  TContext
> => {
  return useMutation(getMergeAuthorsMutationOptions(options));
};

export const getDecideEntityCandidateUrl = (id: number) => {
  return `/api/admin/entity-resolution/candidates/${id}`;
};

export const decideEntityCandidate = async (
  id: number,
  entityCandidateDecision: EntityCandidateDecision,
  options?: RequestInit,
): Promise<EntityResolutionWorkspace> => {
  return customFetch<EntityResolutionWorkspace>(
    getDecideEntityCandidateUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(entityCandidateDecision),
    },
  );
};

export const getDecideEntityCandidateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decideEntityCandidate>>,
    TError,
    { id: number; data: BodyType<EntityCandidateDecision> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof decideEntityCandidate>>,
  TError,
  { id: number; data: BodyType<EntityCandidateDecision> },
  TContext
> => {
  const mutationKey = ["decideEntityCandidate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof decideEntityCandidate>>,
    { id: number; data: BodyType<EntityCandidateDecision> }
  > = (props) => {
    const { id, data } = props ?? {};

    return decideEntityCandidate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DecideEntityCandidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof decideEntityCandidate>>
>;
export type DecideEntityCandidateMutationBody =
  BodyType<EntityCandidateDecision>;
export type DecideEntityCandidateMutationError = ErrorType<unknown>;

export const useDecideEntityCandidate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decideEntityCandidate>>,
    TError,
    { id: number; data: BodyType<EntityCandidateDecision> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof decideEntityCandidate>>,
  TError,
  { id: number; data: BodyType<EntityCandidateDecision> },
  TContext
> => {
  return useMutation(getDecideEntityCandidateMutationOptions(options));
};

export const getControlEntityJobUrl = (id: number) => {
  return `/api/admin/entity-resolution/jobs/${id}`;
};

export const controlEntityJob = async (
  id: number,
  entityJobControl: EntityJobControl,
  options?: RequestInit,
): Promise<EntityResolutionJob> => {
  return customFetch<EntityResolutionJob>(getControlEntityJobUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(entityJobControl),
  });
};

export const getControlEntityJobMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof controlEntityJob>>,
    TError,
    { id: number; data: BodyType<EntityJobControl> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof controlEntityJob>>,
  TError,
  { id: number; data: BodyType<EntityJobControl> },
  TContext
> => {
  const mutationKey = ["controlEntityJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof controlEntityJob>>,
    { id: number; data: BodyType<EntityJobControl> }
  > = (props) => {
    const { id, data } = props ?? {};

    return controlEntityJob(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ControlEntityJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof controlEntityJob>>
>;
export type ControlEntityJobMutationBody = BodyType<EntityJobControl>;
export type ControlEntityJobMutationError = ErrorType<unknown>;

export const useControlEntityJob = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof controlEntityJob>>,
    TError,
    { id: number; data: BodyType<EntityJobControl> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof controlEntityJob>>,
  TError,
  { id: number; data: BodyType<EntityJobControl> },
  TContext
> => {
  return useMutation(getControlEntityJobMutationOptions(options));
};

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Exact unfiltered signed-out Library count. Ignores authentication and browsing filters.
 * @summary Count quotes accessible in the public Library
 */
export const getGetPublicLibraryCountUrl = () => {
  return `/api/quotes/library-count`;
};

export const getPublicLibraryCount = async (
  options?: RequestInit,
): Promise<GetPublicLibraryCount200> => {
  return customFetch<GetPublicLibraryCount200>(getGetPublicLibraryCountUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPublicLibraryCountQueryKey = () => {
  return [`/api/quotes/library-count`] as const;
};

export const getGetPublicLibraryCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicLibraryCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPublicLibraryCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPublicLibraryCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPublicLibraryCount>>
  > = ({ signal }) => getPublicLibraryCount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicLibraryCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPublicLibraryCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicLibraryCount>>
>;
export type GetPublicLibraryCountQueryError = ErrorType<unknown>;

/**
 * @summary Count quotes accessible in the public Library
 */

export function useGetPublicLibraryCount<
  TData = Awaited<ReturnType<typeof getPublicLibraryCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPublicLibraryCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPublicLibraryCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Paginated list of quotes, filterable by tag, status, and era
 * @summary List quotes
 */
export const getGetQuotesUrl = (params?: GetQuotesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/quotes?${stringifiedParams}`
    : `/api/quotes`;
};

export const getQuotes = async (
  params?: GetQuotesParams,
  options?: RequestInit,
): Promise<PaginatedQuotes> => {
  return customFetch<PaginatedQuotes>(getGetQuotesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetQuotesQueryKey = (params?: GetQuotesParams) => {
  return [`/api/quotes`, ...(params ? [params] : [])] as const;
};

export const getGetQuotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuotes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuotesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuotes>>> = ({
    signal,
  }) => getQuotes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuotes>>
>;
export type GetQuotesQueryError = ErrorType<unknown>;

/**
 * @summary List quotes
 */

export function useGetQuotes<
  TData = Awaited<ReturnType<typeof getQuotes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuotesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a candidate quote
 */
export const getCreateQuoteUrl = () => {
  return `/api/quotes`;
};

export const createQuote = async (
  createQuoteBody: CreateQuoteBody,
  options?: RequestInit,
): Promise<QuoteWithTags> => {
  return customFetch<QuoteWithTags>(getCreateQuoteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createQuoteBody),
  });
};

export const getCreateQuoteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuote>>,
    TError,
    { data: BodyType<CreateQuoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createQuote>>,
  TError,
  { data: BodyType<CreateQuoteBody> },
  TContext
> => {
  const mutationKey = ["createQuote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuote>>,
    { data: BodyType<CreateQuoteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createQuote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateQuoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createQuote>>
>;
export type CreateQuoteMutationBody = BodyType<CreateQuoteBody>;
export type CreateQuoteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a candidate quote
 */
export const useCreateQuote = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createQuote>>,
    TError,
    { data: BodyType<CreateQuoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createQuote>>,
  TError,
  { data: BodyType<CreateQuoteBody> },
  TContext
> => {
  return useMutation(getCreateQuoteMutationOptions(options));
};

/**
 * Returns a deterministic date-seeded approved quote for today
 * @summary Get today's daily quote
 */
export const getGetDailyQuoteUrl = () => {
  return `/api/quotes/daily`;
};

export const getDailyQuote = async (
  options?: RequestInit,
): Promise<QuoteWithTags> => {
  return customFetch<QuoteWithTags>(getGetDailyQuoteUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDailyQuoteQueryKey = () => {
  return [`/api/quotes/daily`] as const;
};

export const getGetDailyQuoteQueryOptions = <
  TData = Awaited<ReturnType<typeof getDailyQuote>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDailyQuote>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDailyQuoteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyQuote>>> = ({
    signal,
  }) => getDailyQuote({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDailyQuote>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDailyQuoteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDailyQuote>>
>;
export type GetDailyQuoteQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get today's daily quote
 */

export function useGetDailyQuote<
  TData = Awaited<ReturnType<typeof getDailyQuote>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDailyQuote>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDailyQuoteQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns quotes favorited by the current user (stub userId)
 * @summary List favorited quotes
 */
export const getGetQuotesFavoritesUrl = () => {
  return `/api/quotes/favorites`;
};

export const getQuotesFavorites = async (
  options?: RequestInit,
): Promise<QuoteWithTags[]> => {
  return customFetch<QuoteWithTags[]>(getGetQuotesFavoritesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetQuotesFavoritesQueryKey = () => {
  return [`/api/quotes/favorites`] as const;
};

export const getGetQuotesFavoritesQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuotesFavorites>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getQuotesFavorites>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuotesFavoritesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuotesFavorites>>
  > = ({ signal }) => getQuotesFavorites({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuotesFavorites>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuotesFavoritesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuotesFavorites>>
>;
export type GetQuotesFavoritesQueryError = ErrorType<unknown>;

/**
 * @summary List favorited quotes
 */

export function useGetQuotesFavorites<
  TData = Awaited<ReturnType<typeof getQuotesFavorites>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getQuotesFavorites>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuotesFavoritesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns quotes recommended for the user. When the user has favorited quotes with embeddings, returns the top-N most similar approved quotes by centroid cosine distance (pgvector). Falls back to approved random selection when no favorites or embeddings are available.

 * @summary Get recommended quotes
 */
export const getGetQuotesRecommendationsUrl = (
  params?: GetQuotesRecommendationsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/quotes/recommendations?${stringifiedParams}`
    : `/api/quotes/recommendations`;
};

export const getQuotesRecommendations = async (
  params?: GetQuotesRecommendationsParams,
  options?: RequestInit,
): Promise<RecommendedQuote[]> => {
  return customFetch<RecommendedQuote[]>(
    getGetQuotesRecommendationsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetQuotesRecommendationsQueryKey = (
  params?: GetQuotesRecommendationsParams,
) => {
  return [`/api/quotes/recommendations`, ...(params ? [params] : [])] as const;
};

export const getGetQuotesRecommendationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuotesRecommendations>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuotesRecommendationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuotesRecommendations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuotesRecommendationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuotesRecommendations>>
  > = ({ signal }) =>
    getQuotesRecommendations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuotesRecommendations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuotesRecommendationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuotesRecommendations>>
>;
export type GetQuotesRecommendationsQueryError = ErrorType<unknown>;

/**
 * @summary Get recommended quotes
 */

export function useGetQuotesRecommendations<
  TData = Awaited<ReturnType<typeof getQuotesRecommendations>>,
  TError = ErrorType<unknown>,
>(
  params?: GetQuotesRecommendationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuotesRecommendations>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuotesRecommendationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single quote
 */
export const getGetQuoteUrl = (id: number) => {
  return `/api/quotes/${id}`;
};

export const getQuote = async (
  id: number,
  options?: RequestInit,
): Promise<QuoteWithTags> => {
  return customFetch<QuoteWithTags>(getGetQuoteUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetQuoteQueryKey = (id: number) => {
  return [`/api/quotes/${id}`] as const;
};

export const getGetQuoteQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuote>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuote>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuoteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuote>>> = ({
    signal,
  }) => getQuote(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getQuote>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetQuoteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuote>>
>;
export type GetQuoteQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a single quote
 */

export function useGetQuote<
  TData = Awaited<ReturnType<typeof getQuote>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuote>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuoteQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Approve or reject a quote
 */
export const getUpdateQuoteStatusUrl = (id: number) => {
  return `/api/quotes/${id}/status`;
};

export const updateQuoteStatus = async (
  id: number,
  updateQuoteStatusBody: UpdateQuoteStatusBody,
  options?: RequestInit,
): Promise<QuoteWithTags> => {
  return customFetch<QuoteWithTags>(getUpdateQuoteStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateQuoteStatusBody),
  });
};

export const getUpdateQuoteStatusMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuoteStatus>>,
    TError,
    { id: number; data: BodyType<UpdateQuoteStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateQuoteStatus>>,
  TError,
  { id: number; data: BodyType<UpdateQuoteStatusBody> },
  TContext
> => {
  const mutationKey = ["updateQuoteStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateQuoteStatus>>,
    { id: number; data: BodyType<UpdateQuoteStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateQuoteStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateQuoteStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateQuoteStatus>>
>;
export type UpdateQuoteStatusMutationBody = BodyType<UpdateQuoteStatusBody>;
export type UpdateQuoteStatusMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Approve or reject a quote
 */
export const useUpdateQuoteStatus = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuoteStatus>>,
    TError,
    { id: number; data: BodyType<UpdateQuoteStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateQuoteStatus>>,
  TError,
  { id: number; data: BodyType<UpdateQuoteStatusBody> },
  TContext
> => {
  return useMutation(getUpdateQuoteStatusMutationOptions(options));
};

/**
 * Marks all existing centroids stale and spawns the compute-author-centroids script as a background job. Returns 202 immediately. Check server logs for progress. Use after a failed/partial enrichment run or to repair production profile data.

 * @summary Force a full recompute of author centroids and similar-author rows (admin only)
 */
export const getRecomputeCentroidsUrl = () => {
  return `/api/admin/recompute-centroids`;
};

export const recomputeCentroids = async (
  options?: RequestInit,
): Promise<RecomputeCentroids202> => {
  return customFetch<RecomputeCentroids202>(getRecomputeCentroidsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRecomputeCentroidsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recomputeCentroids>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recomputeCentroids>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["recomputeCentroids"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recomputeCentroids>>,
    void
  > = () => {
    return recomputeCentroids(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecomputeCentroidsMutationResult = NonNullable<
  Awaited<ReturnType<typeof recomputeCentroids>>
>;

export type RecomputeCentroidsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Force a full recompute of author centroids and similar-author rows (admin only)
 */
export const useRecomputeCentroids = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recomputeCentroids>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recomputeCentroids>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRecomputeCentroidsMutationOptions(options));
};

/**
 * Reads the checkpoint file and returns chunk-level progress for the enrichment pipeline.
 * @summary OpenAI batch enrichment pipeline status (admin only)
 */
export const getGetEnrichmentStatusUrl = () => {
  return `/api/admin/enrichment-status`;
};

export const getEnrichmentStatus = async (
  options?: RequestInit,
): Promise<EnrichmentPipelineStatus> => {
  return customFetch<EnrichmentPipelineStatus>(getGetEnrichmentStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEnrichmentStatusQueryKey = () => {
  return [`/api/admin/enrichment-status`] as const;
};

export const getGetEnrichmentStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnrichmentStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEnrichmentStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEnrichmentStatus>>
  > = ({ signal }) => getEnrichmentStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnrichmentStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnrichmentStatus>>
>;
export type GetEnrichmentStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary OpenAI batch enrichment pipeline status (admin only)
 */

export function useGetEnrichmentStatus<
  TData = Awaited<ReturnType<typeof getEnrichmentStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnrichmentStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns counts by status and AI-verification state so admins can gauge pipeline progress.
 * @summary Enrichment stats for the quote corpus (admin only)
 */
export const getGetHarvestStatsUrl = () => {
  return `/api/harvest/stats`;
};

export const getHarvestStats = async (
  options?: RequestInit,
): Promise<HarvestStats> => {
  return customFetch<HarvestStats>(getGetHarvestStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetHarvestStatsQueryKey = () => {
  return [`/api/harvest/stats`] as const;
};

export const getGetHarvestStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getHarvestStats>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getHarvestStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHarvestStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHarvestStats>>> = ({
    signal,
  }) => getHarvestStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHarvestStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHarvestStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHarvestStats>>
>;
export type GetHarvestStatsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Enrichment stats for the quote corpus (admin only)
 */

export function useGetHarvestStats<
  TData = Awaited<ReturnType<typeof getHarvestStats>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getHarvestStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHarvestStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Durable enrichment rollout summary (admin only)
 */
export const getGetEnrichmentGovernanceSummaryUrl = () => {
  return `/api/admin/enrichment-governance/summary`;
};

export const getEnrichmentGovernanceSummary = async (
  options?: RequestInit,
): Promise<EnrichmentGovernanceSummary> => {
  return customFetch<EnrichmentGovernanceSummary>(
    getGetEnrichmentGovernanceSummaryUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetEnrichmentGovernanceSummaryQueryKey = () => {
  return [`/api/admin/enrichment-governance/summary`] as const;
};

export const getGetEnrichmentGovernanceSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnrichmentGovernanceSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentGovernanceSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEnrichmentGovernanceSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEnrichmentGovernanceSummary>>
  > = ({ signal }) =>
    getEnrichmentGovernanceSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentGovernanceSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnrichmentGovernanceSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnrichmentGovernanceSummary>>
>;
export type GetEnrichmentGovernanceSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Durable enrichment rollout summary (admin only)
 */

export function useGetEnrichmentGovernanceSummary<
  TData = Awaited<ReturnType<typeof getEnrichmentGovernanceSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentGovernanceSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnrichmentGovernanceSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List active author notability decisions for review
 */
export const getGetAuthorNotabilityReviewsUrl = (
  params?: GetAuthorNotabilityReviewsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/enrichment-governance/authors?${stringifiedParams}`
    : `/api/admin/enrichment-governance/authors`;
};

export const getAuthorNotabilityReviews = async (
  params?: GetAuthorNotabilityReviewsParams,
  options?: RequestInit,
): Promise<AuthorNotabilityReviewList> => {
  return customFetch<AuthorNotabilityReviewList>(
    getGetAuthorNotabilityReviewsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAuthorNotabilityReviewsQueryKey = (
  params?: GetAuthorNotabilityReviewsParams,
) => {
  return [
    `/api/admin/enrichment-governance/authors`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAuthorNotabilityReviewsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthorNotabilityReviews>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAuthorNotabilityReviewsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAuthorNotabilityReviews>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAuthorNotabilityReviewsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAuthorNotabilityReviews>>
  > = ({ signal }) =>
    getAuthorNotabilityReviews(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthorNotabilityReviews>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuthorNotabilityReviewsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthorNotabilityReviews>>
>;
export type GetAuthorNotabilityReviewsQueryError = ErrorType<unknown>;

/**
 * @summary List active author notability decisions for review
 */

export function useGetAuthorNotabilityReviews<
  TData = Awaited<ReturnType<typeof getAuthorNotabilityReviews>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAuthorNotabilityReviewsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAuthorNotabilityReviews>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAuthorNotabilityReviewsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Store a protected human author-notability override
 */
export const getOverrideAuthorNotabilityUrl = (authorName: string) => {
  return `/api/admin/enrichment-governance/authors/${authorName}`;
};

export const overrideAuthorNotability = async (
  authorName: string,
  authorNotabilityOverride: AuthorNotabilityOverride,
  options?: RequestInit,
): Promise<AuthorNotabilityReview> => {
  return customFetch<AuthorNotabilityReview>(
    getOverrideAuthorNotabilityUrl(authorName),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(authorNotabilityOverride),
    },
  );
};

export const getOverrideAuthorNotabilityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof overrideAuthorNotability>>,
    TError,
    { authorName: string; data: BodyType<AuthorNotabilityOverride> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof overrideAuthorNotability>>,
  TError,
  { authorName: string; data: BodyType<AuthorNotabilityOverride> },
  TContext
> => {
  const mutationKey = ["overrideAuthorNotability"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof overrideAuthorNotability>>,
    { authorName: string; data: BodyType<AuthorNotabilityOverride> }
  > = (props) => {
    const { authorName, data } = props ?? {};

    return overrideAuthorNotability(authorName, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OverrideAuthorNotabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof overrideAuthorNotability>>
>;
export type OverrideAuthorNotabilityMutationBody =
  BodyType<AuthorNotabilityOverride>;
export type OverrideAuthorNotabilityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Store a protected human author-notability override
 */
export const useOverrideAuthorNotability = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof overrideAuthorNotability>>,
    TError,
    { authorName: string; data: BodyType<AuthorNotabilityOverride> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof overrideAuthorNotability>>,
  TError,
  { authorName: string; data: BodyType<AuthorNotabilityOverride> },
  TContext
> => {
  return useMutation(getOverrideAuthorNotabilityMutationOptions(options));
};

/**
 * @summary Compare current public state to the deterministic policy projection
 */
export const getGetEnrichmentBlastRadiusUrl = () => {
  return `/api/admin/enrichment-governance/blast-radius`;
};

export const getEnrichmentBlastRadius = async (
  options?: RequestInit,
): Promise<EnrichmentBlastRadius> => {
  return customFetch<EnrichmentBlastRadius>(getGetEnrichmentBlastRadiusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEnrichmentBlastRadiusQueryKey = () => {
  return [`/api/admin/enrichment-governance/blast-radius`] as const;
};

export const getGetEnrichmentBlastRadiusQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnrichmentBlastRadius>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentBlastRadius>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEnrichmentBlastRadiusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEnrichmentBlastRadius>>
  > = ({ signal }) => getEnrichmentBlastRadius({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentBlastRadius>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnrichmentBlastRadiusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnrichmentBlastRadius>>
>;
export type GetEnrichmentBlastRadiusQueryError = ErrorType<unknown>;

/**
 * @summary Compare current public state to the deterministic policy projection
 */

export function useGetEnrichmentBlastRadius<
  TData = Awaited<ReturnType<typeof getEnrichmentBlastRadius>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEnrichmentBlastRadius>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnrichmentBlastRadiusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Queue targeted quote or author fact reprocessing
 */
export const getCreateEnrichmentWorkItemUrl = () => {
  return `/api/admin/enrichment-governance/work-items`;
};

export const createEnrichmentWorkItem = async (
  enrichmentWorkItemInput: EnrichmentWorkItemInput,
  options?: RequestInit,
): Promise<EnrichmentWorkItemRequest> => {
  return customFetch<EnrichmentWorkItemRequest>(
    getCreateEnrichmentWorkItemUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(enrichmentWorkItemInput),
    },
  );
};

export const getCreateEnrichmentWorkItemMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEnrichmentWorkItem>>,
    TError,
    { data: BodyType<EnrichmentWorkItemInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEnrichmentWorkItem>>,
  TError,
  { data: BodyType<EnrichmentWorkItemInput> },
  TContext
> => {
  const mutationKey = ["createEnrichmentWorkItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEnrichmentWorkItem>>,
    { data: BodyType<EnrichmentWorkItemInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createEnrichmentWorkItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEnrichmentWorkItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEnrichmentWorkItem>>
>;
export type CreateEnrichmentWorkItemMutationBody =
  BodyType<EnrichmentWorkItemInput>;
export type CreateEnrichmentWorkItemMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Queue targeted quote or author fact reprocessing
 */
export const useCreateEnrichmentWorkItem = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEnrichmentWorkItem>>,
    TError,
    { data: BodyType<EnrichmentWorkItemInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEnrichmentWorkItem>>,
  TError,
  { data: BodyType<EnrichmentWorkItemInput> },
  TContext
> => {
  return useMutation(getCreateEnrichmentWorkItemMutationOptions(options));
};

/**
 * Paginated list of approved user-submitted quotes with submitter username. Public — no authentication required.
 * @summary List community-submitted quotes
 */
export const getGetCommunityQuotesUrl = (params?: GetCommunityQuotesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/quotes/community?${stringifiedParams}`
    : `/api/quotes/community`;
};

export const getCommunityQuotes = async (
  params?: GetCommunityQuotesParams,
  options?: RequestInit,
): Promise<PaginatedCommunityQuotes> => {
  return customFetch<PaginatedCommunityQuotes>(
    getGetCommunityQuotesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCommunityQuotesQueryKey = (
  params?: GetCommunityQuotesParams,
) => {
  return [`/api/quotes/community`, ...(params ? [params] : [])] as const;
};

export const getGetCommunityQuotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunityQuotes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCommunityQuotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCommunityQuotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCommunityQuotesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCommunityQuotes>>
  > = ({ signal }) => getCommunityQuotes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunityQuotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCommunityQuotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunityQuotes>>
>;
export type GetCommunityQuotesQueryError = ErrorType<unknown>;

/**
 * @summary List community-submitted quotes
 */

export function useGetCommunityQuotes<
  TData = Awaited<ReturnType<typeof getCommunityQuotes>>,
  TError = ErrorType<unknown>,
>(
  params?: GetCommunityQuotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCommunityQuotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCommunityQuotesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List quotes with the most dismissals (admin only)
 */
export const getGetPoorlyReceivedQuotesUrl = (
  params?: GetPoorlyReceivedQuotesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/quotes/poorly-received?${stringifiedParams}`
    : `/api/quotes/poorly-received`;
};

export const getPoorlyReceivedQuotes = async (
  params?: GetPoorlyReceivedQuotesParams,
  options?: RequestInit,
): Promise<PoorlyReceivedQuote[]> => {
  return customFetch<PoorlyReceivedQuote[]>(
    getGetPoorlyReceivedQuotesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPoorlyReceivedQuotesQueryKey = (
  params?: GetPoorlyReceivedQuotesParams,
) => {
  return [`/api/quotes/poorly-received`, ...(params ? [params] : [])] as const;
};

export const getGetPoorlyReceivedQuotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPoorlyReceivedQuotes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetPoorlyReceivedQuotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPoorlyReceivedQuotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPoorlyReceivedQuotesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPoorlyReceivedQuotes>>
  > = ({ signal }) =>
    getPoorlyReceivedQuotes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPoorlyReceivedQuotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPoorlyReceivedQuotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPoorlyReceivedQuotes>>
>;
export type GetPoorlyReceivedQuotesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List quotes with the most dismissals (admin only)
 */

export function useGetPoorlyReceivedQuotes<
  TData = Awaited<ReturnType<typeof getPoorlyReceivedQuotes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetPoorlyReceivedQuotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPoorlyReceivedQuotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPoorlyReceivedQuotesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Records a soft-reject signal for the authenticated user. Idempotent — calling it again for the same quote is a no-op. The quote is excluded from future recommendations for this user.

 * @summary Dismiss a quote ("Not for me")
 */
export const getDismissQuoteUrl = (id: number) => {
  return `/api/quotes/${id}/dismiss`;
};

export const dismissQuote = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDismissQuoteUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDismissQuoteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissQuote>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissQuote>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["dismissQuote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissQuote>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return dismissQuote(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissQuoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissQuote>>
>;

export type DismissQuoteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Dismiss a quote ("Not for me")
 */
export const useDismissQuote = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissQuote>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissQuote>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDismissQuoteMutationOptions(options));
};

/**
 * Upserts the authenticated user's vote (up or down) on a quote. Casting the same vote again is idempotent. Casting the opposite vote switches the existing vote. Use DELETE to remove a vote entirely.

 * @summary Cast or change a vote on a community quote
 */
export const getVoteQuoteUrl = (id: number) => {
  return `/api/quotes/${id}/vote`;
};

export const voteQuote = async (
  id: number,
  voteQuoteBody: VoteQuoteBody,
  options?: RequestInit,
): Promise<VoteQuoteResponse> => {
  return customFetch<VoteQuoteResponse>(getVoteQuoteUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(voteQuoteBody),
  });
};

export const getVoteQuoteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voteQuote>>,
    TError,
    { id: number; data: BodyType<VoteQuoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof voteQuote>>,
  TError,
  { id: number; data: BodyType<VoteQuoteBody> },
  TContext
> => {
  const mutationKey = ["voteQuote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof voteQuote>>,
    { id: number; data: BodyType<VoteQuoteBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return voteQuote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VoteQuoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof voteQuote>>
>;
export type VoteQuoteMutationBody = BodyType<VoteQuoteBody>;
export type VoteQuoteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Cast or change a vote on a community quote
 */
export const useVoteQuote = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voteQuote>>,
    TError,
    { id: number; data: BodyType<VoteQuoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof voteQuote>>,
  TError,
  { id: number; data: BodyType<VoteQuoteBody> },
  TContext
> => {
  return useMutation(getVoteQuoteMutationOptions(options));
};

/**
 * @summary Remove the authenticated user's vote from a community quote
 */
export const getDeleteQuoteVoteUrl = (id: number) => {
  return `/api/quotes/${id}/vote`;
};

export const deleteQuoteVote = async (
  id: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteQuoteVoteUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteQuoteVoteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuoteVote>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteQuoteVote>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteQuoteVote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteQuoteVote>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteQuoteVote(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteQuoteVoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteQuoteVote>>
>;

export type DeleteQuoteVoteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Remove the authenticated user's vote from a community quote
 */
export const useDeleteQuoteVote = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuoteVote>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteQuoteVote>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteQuoteVoteMutationOptions(options));
};

/**
 * @summary Toggle favorite status for a quote
 */
export const getToggleQuoteFavoriteUrl = (id: number) => {
  return `/api/quotes/${id}/favorite`;
};

export const toggleQuoteFavorite = async (
  id: number,
  options?: RequestInit,
): Promise<FavoriteToggleResponse> => {
  return customFetch<FavoriteToggleResponse>(getToggleQuoteFavoriteUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getToggleQuoteFavoriteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleQuoteFavorite>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleQuoteFavorite>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["toggleQuoteFavorite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleQuoteFavorite>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return toggleQuoteFavorite(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ToggleQuoteFavoriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleQuoteFavorite>>
>;

export type ToggleQuoteFavoriteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Toggle favorite status for a quote
 */
export const useToggleQuoteFavorite = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleQuoteFavorite>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof toggleQuoteFavorite>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getToggleQuoteFavoriteMutationOptions(options));
};

/**
 * Returns the top 10 most similar approved quotes by embedding cosine distance. Falls back to tag-overlap similarity when embeddings are unavailable.

 * @summary Get quotes similar to a given quote
 */
export const getGetQuoteSimilarUrl = (
  id: number,
  params?: GetQuoteSimilarParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/quotes/${id}/similar?${stringifiedParams}`
    : `/api/quotes/${id}/similar`;
};

export const getQuoteSimilar = async (
  id: number,
  params?: GetQuoteSimilarParams,
  options?: RequestInit,
): Promise<QuoteWithTags[]> => {
  return customFetch<QuoteWithTags[]>(getGetQuoteSimilarUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetQuoteSimilarQueryKey = (
  id: number,
  params?: GetQuoteSimilarParams,
) => {
  return [`/api/quotes/${id}/similar`, ...(params ? [params] : [])] as const;
};

export const getGetQuoteSimilarQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuoteSimilar>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  params?: GetQuoteSimilarParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteSimilar>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuoteSimilarQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteSimilar>>> = ({
    signal,
  }) => getQuoteSimilar(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteSimilar>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuoteSimilarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuoteSimilar>>
>;
export type GetQuoteSimilarQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get quotes similar to a given quote
 */

export function useGetQuoteSimilar<
  TData = Awaited<ReturnType<typeof getQuoteSimilar>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  params?: GetQuoteSimilarParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteSimilar>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuoteSimilarQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a cached bio for the author (or null) plus up to 3 other approved quotes by the same author.
 * @summary Get author bio and other quotes
 */
export const getGetAuthorBioUrl = (
  name: string,
  params?: GetAuthorBioParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/authors/${name}/bio?${stringifiedParams}`
    : `/api/authors/${name}/bio`;
};

export const getAuthorBio = async (
  name: string,
  params?: GetAuthorBioParams,
  options?: RequestInit,
): Promise<AuthorBioResponse> => {
  return customFetch<AuthorBioResponse>(getGetAuthorBioUrl(name, params), {
    ...options,
    method: "GET",
  });
};

export const getGetAuthorBioQueryKey = (
  name: string,
  params?: GetAuthorBioParams,
) => {
  return [`/api/authors/${name}/bio`, ...(params ? [params] : [])] as const;
};

export const getGetAuthorBioQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthorBio>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  params?: GetAuthorBioParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAuthorBio>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAuthorBioQueryKey(name, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthorBio>>> = ({
    signal,
  }) => getAuthorBio(name, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthorBio>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuthorBioQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthorBio>>
>;
export type GetAuthorBioQueryError = ErrorType<unknown>;

/**
 * @summary Get author bio and other quotes
 */

export function useGetAuthorBio<
  TData = Awaited<ReturnType<typeof getAuthorBio>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  params?: GetAuthorBioParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAuthorBio>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAuthorBioQueryOptions(name, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the author's thematic fingerprint (derived from the centroid of their approved quote embeddings) and their three most similar authors. Returns empty arrays when the author has insufficient embeddings.

 * @summary Get author theme profile and similar authors
 */
export const getGetAuthorProfileUrl = (name: string) => {
  return `/api/authors/${name}/profile`;
};

export const getAuthorProfile = async (
  name: string,
  options?: RequestInit,
): Promise<AuthorProfileResponse> => {
  return customFetch<AuthorProfileResponse>(getGetAuthorProfileUrl(name), {
    ...options,
    method: "GET",
  });
};

export const getGetAuthorProfileQueryKey = (name: string) => {
  return [`/api/authors/${name}/profile`] as const;
};

export const getGetAuthorProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthorProfile>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAuthorProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuthorProfileQueryKey(name);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAuthorProfile>>
  > = ({ signal }) => getAuthorProfile(name, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!name,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthorProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuthorProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthorProfile>>
>;
export type GetAuthorProfileQueryError = ErrorType<unknown>;

/**
 * @summary Get author theme profile and similar authors
 */

export function useGetAuthorProfile<
  TData = Awaited<ReturnType<typeof getAuthorProfile>>,
  TError = ErrorType<unknown>,
>(
  name: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAuthorProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAuthorProfileQueryOptions(name, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all tags
 */
export const getGetTagsUrl = () => {
  return `/api/tags`;
};

export const getTags = async (options?: RequestInit): Promise<Tag[]> => {
  return customFetch<Tag[]>(getGetTagsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTagsQueryKey = () => {
  return [`/api/tags`] as const;
};

export const getGetTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTags>>> = ({
    signal,
  }) => getTags({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTags>>
>;
export type GetTagsQueryError = ErrorType<unknown>;

/**
 * @summary List all tags
 */

export function useGetTags<
  TData = Awaited<ReturnType<typeof getTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getTags>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the authenticated user's username and avatar URL. Returns nulls if the user has not completed onboarding.
 * @summary Get current user profile
 */
export const getGetProfileMeUrl = () => {
  return `/api/profile/me`;
};

export const getProfileMe = async (
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getGetProfileMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetProfileMeQueryKey = () => {
  return [`/api/profile/me`] as const;
};

export const getGetProfileMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfileMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getProfileMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileMe>>> = ({
    signal,
  }) => getProfileMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfileMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfileMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfileMe>>
>;
export type GetProfileMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user profile
 */

export function useGetProfileMe<
  TData = Awaited<ReturnType<typeof getProfileMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getProfileMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfileMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates or updates the authenticated user's username and/or avatar URL.
 * @summary Upsert current user profile
 */
export const getUpdateProfileMeUrl = () => {
  return `/api/profile/me`;
};

export const updateProfileMe = async (
  updateProfileBody: UpdateProfileBody,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getUpdateProfileMeUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProfileBody),
  });
};

export const getUpdateProfileMeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfileMe>>,
    TError,
    { data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfileMe>>,
  TError,
  { data: BodyType<UpdateProfileBody> },
  TContext
> => {
  const mutationKey = ["updateProfileMe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfileMe>>,
    { data: BodyType<UpdateProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateProfileMe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfileMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProfileMe>>
>;
export type UpdateProfileMeMutationBody = BodyType<UpdateProfileBody>;
export type UpdateProfileMeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upsert current user profile
 */
export const useUpdateProfileMe = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfileMe>>,
    TError,
    { data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProfileMe>>,
  TError,
  { data: BodyType<UpdateProfileBody> },
  TContext
> => {
  return useMutation(getUpdateProfileMeMutationOptions(options));
};

/**
 * Returns a short-lived presigned PUT URL for uploading a file directly to Google Cloud Storage, plus the objectPath to store in the user profile. Only image uploads under 2 MB are accepted. Requires authentication.

 * @summary Request a presigned GCS upload URL
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  requestUploadUrlBody: RequestUploadUrlBody,
  options?: RequestInit,
): Promise<RequestUploadUrlResponse> => {
  return customFetch<RequestUploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(requestUploadUrlBody),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<RequestUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<RequestUploadUrlBody> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<RequestUploadUrlBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<RequestUploadUrlBody>;
export type RequestUploadUrlMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a presigned GCS upload URL
 */
export const useRequestUploadUrl = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<RequestUploadUrlBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<RequestUploadUrlBody> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * Persists the user's email notification opt-in, frequency, hour, and destination address.
 * @summary Update email notification preferences
 */
export const getUpdateNotificationSettingsUrl = () => {
  return `/api/profile/notification-settings`;
};

export const updateNotificationSettings = async (
  updateNotificationSettingsBody: UpdateNotificationSettingsBody,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getUpdateNotificationSettingsUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateNotificationSettingsBody),
  });
};

export const getUpdateNotificationSettingsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationSettings>>,
    TError,
    { data: BodyType<UpdateNotificationSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNotificationSettings>>,
  TError,
  { data: BodyType<UpdateNotificationSettingsBody> },
  TContext
> => {
  const mutationKey = ["updateNotificationSettings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNotificationSettings>>,
    { data: BodyType<UpdateNotificationSettingsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateNotificationSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNotificationSettings>>
>;
export type UpdateNotificationSettingsMutationBody =
  BodyType<UpdateNotificationSettingsBody>;
export type UpdateNotificationSettingsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update email notification preferences
 */
export const useUpdateNotificationSettings = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNotificationSettings>>,
    TError,
    { data: BodyType<UpdateNotificationSettingsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateNotificationSettings>>,
  TError,
  { data: BodyType<UpdateNotificationSettingsBody> },
  TContext
> => {
  return useMutation(getUpdateNotificationSettingsMutationOptions(options));
};

/**
 * Persists whether the user opts into profane and sexually flagged quotes.
 * @summary Update flagged-content preferences
 */
export const getUpdateContentPreferencesUrl = () => {
  return `/api/profile/content-preferences`;
};

export const updateContentPreferences = async (
  updateContentPreferencesBody: UpdateContentPreferencesBody,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getUpdateContentPreferencesUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateContentPreferencesBody),
  });
};

export const getUpdateContentPreferencesMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContentPreferences>>,
    TError,
    { data: BodyType<UpdateContentPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContentPreferences>>,
  TError,
  { data: BodyType<UpdateContentPreferencesBody> },
  TContext
> => {
  const mutationKey = ["updateContentPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContentPreferences>>,
    { data: BodyType<UpdateContentPreferencesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateContentPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContentPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContentPreferences>>
>;
export type UpdateContentPreferencesMutationBody =
  BodyType<UpdateContentPreferencesBody>;
export type UpdateContentPreferencesMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update flagged-content preferences
 */
export const useUpdateContentPreferences = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContentPreferences>>,
    TError,
    { data: BodyType<UpdateContentPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateContentPreferences>>,
  TError,
  { data: BodyType<UpdateContentPreferencesBody> },
  TContext
> => {
  return useMutation(getUpdateContentPreferencesMutationOptions(options));
};

/**
 * Returns up to 3 pinned quotes with their position and full quote data.
 * @summary Get the current user's pinned quotes
 */
export const getGetProfilePinnedQuotesUrl = () => {
  return `/api/profile/pinned-quotes`;
};

export const getProfilePinnedQuotes = async (
  options?: RequestInit,
): Promise<PinnedQuote[]> => {
  return customFetch<PinnedQuote[]>(getGetProfilePinnedQuotesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetProfilePinnedQuotesQueryKey = () => {
  return [`/api/profile/pinned-quotes`] as const;
};

export const getGetProfilePinnedQuotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfilePinnedQuotes>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getProfilePinnedQuotes>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProfilePinnedQuotesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProfilePinnedQuotes>>
  > = ({ signal }) => getProfilePinnedQuotes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfilePinnedQuotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfilePinnedQuotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfilePinnedQuotes>>
>;
export type GetProfilePinnedQuotesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the current user's pinned quotes
 */

export function useGetProfilePinnedQuotes<
  TData = Awaited<ReturnType<typeof getProfilePinnedQuotes>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getProfilePinnedQuotes>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfilePinnedQuotesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Atomically replaces all pinned quotes. Send an empty array to clear all pins.
 * @summary Replace the current user's pinned quotes
 */
export const getUpdateProfilePinnedQuotesUrl = () => {
  return `/api/profile/pinned-quotes`;
};

export const updateProfilePinnedQuotes = async (
  pinQuoteBody: PinQuoteBody[],
  options?: RequestInit,
): Promise<UpdatePinnedQuotesResponse> => {
  return customFetch<UpdatePinnedQuotesResponse>(
    getUpdateProfilePinnedQuotesUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(pinQuoteBody),
    },
  );
};

export const getUpdateProfilePinnedQuotesMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfilePinnedQuotes>>,
    TError,
    { data: BodyType<PinQuoteBody[]> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfilePinnedQuotes>>,
  TError,
  { data: BodyType<PinQuoteBody[]> },
  TContext
> => {
  const mutationKey = ["updateProfilePinnedQuotes"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfilePinnedQuotes>>,
    { data: BodyType<PinQuoteBody[]> }
  > = (props) => {
    const { data } = props ?? {};

    return updateProfilePinnedQuotes(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfilePinnedQuotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProfilePinnedQuotes>>
>;
export type UpdateProfilePinnedQuotesMutationBody = BodyType<PinQuoteBody[]>;
export type UpdateProfilePinnedQuotesMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Replace the current user's pinned quotes
 */
export const useUpdateProfilePinnedQuotes = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfilePinnedQuotes>>,
    TError,
    { data: BodyType<PinQuoteBody[]> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProfilePinnedQuotes>>,
  TError,
  { data: BodyType<PinQuoteBody[]> },
  TContext
> => {
  return useMutation(getUpdateProfilePinnedQuotesMutationOptions(options));
};

/**
 * Returns weighted thematic cluster scores derived from the embeddings of the user's favorited quotes. Each cluster has a label and a 0-100 percentage score. Falls back to tag-frequency counts when embeddings are unavailable.

 * @summary Get thematic clusters from the user's favorited quotes
 */
export const getGetProfileQuoteClustersUrl = () => {
  return `/api/profile/quote-clusters`;
};

export const getProfileQuoteClusters = async (
  options?: RequestInit,
): Promise<QuoteCluster[]> => {
  return customFetch<QuoteCluster[]>(getGetProfileQuoteClustersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetProfileQuoteClustersQueryKey = () => {
  return [`/api/profile/quote-clusters`] as const;
};

export const getGetProfileQuoteClustersQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfileQuoteClusters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getProfileQuoteClusters>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProfileQuoteClustersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProfileQuoteClusters>>
  > = ({ signal }) => getProfileQuoteClusters({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfileQuoteClusters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfileQuoteClustersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfileQuoteClusters>>
>;
export type GetProfileQuoteClustersQueryError = ErrorType<unknown>;

/**
 * @summary Get thematic clusters from the user's favorited quotes
 */

export function useGetProfileQuoteClusters<
  TData = Awaited<ReturnType<typeof getProfileQuoteClusters>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getProfileQuoteClusters>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfileQuoteClustersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Submit a quote for admin review (1 per week)
 */
export const getSubmitQuoteUrl = () => {
  return `/api/quotes/submit`;
};

export const submitQuote = async (
  submitQuoteBody: SubmitQuoteBody,
  options?: RequestInit,
): Promise<SubmitQuoteResponse> => {
  return customFetch<SubmitQuoteResponse>(getSubmitQuoteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(submitQuoteBody),
  });
};

export const getSubmitQuoteMutationOptions = <
  TError = ErrorType<ErrorResponse | SubmitRateLimitResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitQuote>>,
    TError,
    { data: BodyType<SubmitQuoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitQuote>>,
  TError,
  { data: BodyType<SubmitQuoteBody> },
  TContext
> => {
  const mutationKey = ["submitQuote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitQuote>>,
    { data: BodyType<SubmitQuoteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return submitQuote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitQuoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitQuote>>
>;
export type SubmitQuoteMutationBody = BodyType<SubmitQuoteBody>;
export type SubmitQuoteMutationError = ErrorType<
  ErrorResponse | SubmitRateLimitResponse
>;

/**
 * @summary Submit a quote for admin review (1 per week)
 */
export const useSubmitQuote = <
  TError = ErrorType<ErrorResponse | SubmitRateLimitResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitQuote>>,
    TError,
    { data: BodyType<SubmitQuoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitQuote>>,
  TError,
  { data: BodyType<SubmitQuoteBody> },
  TContext
> => {
  return useMutation(getSubmitQuoteMutationOptions(options));
};

/**
 * @summary Get the current user's own submission history
 */
export const getGetMySubmissionsUrl = () => {
  return `/api/quotes/submissions/mine`;
};

export const getMySubmissions = async (
  options?: RequestInit,
): Promise<MySubmissionsResponse> => {
  return customFetch<MySubmissionsResponse>(getGetMySubmissionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMySubmissionsQueryKey = () => {
  return [`/api/quotes/submissions/mine`] as const;
};

export const getGetMySubmissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMySubmissions>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMySubmissions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMySubmissionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMySubmissions>>
  > = ({ signal }) => getMySubmissions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMySubmissions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMySubmissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMySubmissions>>
>;
export type GetMySubmissionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the current user's own submission history
 */

export function useGetMySubmissions<
  TData = Awaited<ReturnType<typeof getMySubmissions>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMySubmissions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMySubmissionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all pending user submissions (admin only)
 */
export const getGetQuoteSubmissionsUrl = () => {
  return `/api/quotes/submissions`;
};

export const getQuoteSubmissions = async (
  options?: RequestInit,
): Promise<AdminSubmission[]> => {
  return customFetch<AdminSubmission[]>(getGetQuoteSubmissionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetQuoteSubmissionsQueryKey = () => {
  return [`/api/quotes/submissions`] as const;
};

export const getGetQuoteSubmissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuoteSubmissions>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteSubmissions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQuoteSubmissionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuoteSubmissions>>
  > = ({ signal }) => getQuoteSubmissions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteSubmissions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuoteSubmissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuoteSubmissions>>
>;
export type GetQuoteSubmissionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all pending user submissions (admin only)
 */

export function useGetQuoteSubmissions<
  TData = Awaited<ReturnType<typeof getQuoteSubmissions>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteSubmissions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuoteSubmissionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Approve or reject a user submission (admin only)
 */
export const getUpdateSubmissionStatusUrl = (id: number) => {
  return `/api/quotes/submissions/${id}/status`;
};

export const updateSubmissionStatus = async (
  id: number,
  updateSubmissionStatusBody: UpdateSubmissionStatusBody,
  options?: RequestInit,
): Promise<QuoteSubmission> => {
  return customFetch<QuoteSubmission>(getUpdateSubmissionStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSubmissionStatusBody),
  });
};

export const getUpdateSubmissionStatusMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubmissionStatus>>,
    TError,
    { id: number; data: BodyType<UpdateSubmissionStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSubmissionStatus>>,
  TError,
  { id: number; data: BodyType<UpdateSubmissionStatusBody> },
  TContext
> => {
  const mutationKey = ["updateSubmissionStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSubmissionStatus>>,
    { id: number; data: BodyType<UpdateSubmissionStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSubmissionStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSubmissionStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSubmissionStatus>>
>;
export type UpdateSubmissionStatusMutationBody =
  BodyType<UpdateSubmissionStatusBody>;
export type UpdateSubmissionStatusMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Approve or reject a user submission (admin only)
 */
export const useUpdateSubmissionStatus = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubmissionStatus>>,
    TError,
    { id: number; data: BodyType<UpdateSubmissionStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSubmissionStatus>>,
  TError,
  { id: number; data: BodyType<UpdateSubmissionStatusBody> },
  TContext
> => {
  return useMutation(getUpdateSubmissionStatusMutationOptions(options));
};

/**
 * Public endpoint — works for anonymous and authenticated users. When the caller is signed in, their UID is attached. Anonymous submitters must provide a contactEmail; otherwise admins have no way to reply.

 * @summary Submit feedback (bug report, feature request, general)
 */
export const getCreateFeedbackUrl = () => {
  return `/api/feedback`;
};

export const createFeedback = async (
  createFeedbackBody: CreateFeedbackBody,
  options?: RequestInit,
): Promise<FeedbackItem> => {
  return customFetch<FeedbackItem>(getCreateFeedbackUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createFeedbackBody),
  });
};

export const getCreateFeedbackMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeedback>>,
    TError,
    { data: BodyType<CreateFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFeedback>>,
  TError,
  { data: BodyType<CreateFeedbackBody> },
  TContext
> => {
  const mutationKey = ["createFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFeedback>>,
    { data: BodyType<CreateFeedbackBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createFeedback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFeedback>>
>;
export type CreateFeedbackMutationBody = BodyType<CreateFeedbackBody>;
export type CreateFeedbackMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Submit feedback (bug report, feature request, general)
 */
export const useCreateFeedback = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeedback>>,
    TError,
    { data: BodyType<CreateFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFeedback>>,
  TError,
  { data: BodyType<CreateFeedbackBody> },
  TContext
> => {
  return useMutation(getCreateFeedbackMutationOptions(options));
};

/**
 * @summary List feedback items (admin only)
 */
export const getGetFeedbackItemsUrl = (params?: GetFeedbackItemsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/feedback?${stringifiedParams}`
    : `/api/feedback`;
};

export const getFeedbackItems = async (
  params?: GetFeedbackItemsParams,
  options?: RequestInit,
): Promise<FeedbackItem[]> => {
  return customFetch<FeedbackItem[]>(getGetFeedbackItemsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetFeedbackItemsQueryKey = (
  params?: GetFeedbackItemsParams,
) => {
  return [`/api/feedback`, ...(params ? [params] : [])] as const;
};

export const getGetFeedbackItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedbackItems>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetFeedbackItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFeedbackItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFeedbackItemsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedbackItems>>
  > = ({ signal }) => getFeedbackItems(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedbackItems>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeedbackItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedbackItems>>
>;
export type GetFeedbackItemsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List feedback items (admin only)
 */

export function useGetFeedbackItems<
  TData = Awaited<ReturnType<typeof getFeedbackItems>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetFeedbackItemsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFeedbackItems>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFeedbackItemsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update feedback status or admin notes (admin only)
 */
export const getUpdateFeedbackItemUrl = (id: number) => {
  return `/api/feedback/${id}/status`;
};

export const updateFeedbackItem = async (
  id: number,
  updateFeedbackBody: UpdateFeedbackBody,
  options?: RequestInit,
): Promise<FeedbackItem> => {
  return customFetch<FeedbackItem>(getUpdateFeedbackItemUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateFeedbackBody),
  });
};

export const getUpdateFeedbackItemMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedbackItem>>,
    TError,
    { id: number; data: BodyType<UpdateFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFeedbackItem>>,
  TError,
  { id: number; data: BodyType<UpdateFeedbackBody> },
  TContext
> => {
  const mutationKey = ["updateFeedbackItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFeedbackItem>>,
    { id: number; data: BodyType<UpdateFeedbackBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFeedbackItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFeedbackItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFeedbackItem>>
>;
export type UpdateFeedbackItemMutationBody = BodyType<UpdateFeedbackBody>;
export type UpdateFeedbackItemMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update feedback status or admin notes (admin only)
 */
export const useUpdateFeedbackItem = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeedbackItem>>,
    TError,
    { id: number; data: BodyType<UpdateFeedbackBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFeedbackItem>>,
  TError,
  { id: number; data: BodyType<UpdateFeedbackBody> },
  TContext
> => {
  return useMutation(getUpdateFeedbackItemMutationOptions(options));
};

export const getGetQuoteCurationWorkspaceUrl = (id: number) => {
  return `/api/admin/quotes/${id}/workspace`;
};

export const getQuoteCurationWorkspace = async (
  id: number,
  options?: RequestInit,
): Promise<QuoteCurationWorkspace> => {
  return customFetch<QuoteCurationWorkspace>(
    getGetQuoteCurationWorkspaceUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetQuoteCurationWorkspaceQueryKey = (id: number) => {
  return [`/api/admin/quotes/${id}/workspace`] as const;
};

export const getGetQuoteCurationWorkspaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuoteCurationWorkspace>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteCurationWorkspace>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuoteCurationWorkspaceQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuoteCurationWorkspace>>
  > = ({ signal }) =>
    getQuoteCurationWorkspace(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteCurationWorkspace>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuoteCurationWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuoteCurationWorkspace>>
>;
export type GetQuoteCurationWorkspaceQueryError = ErrorType<unknown>;

export function useGetQuoteCurationWorkspace<
  TData = Awaited<ReturnType<typeof getQuoteCurationWorkspace>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteCurationWorkspace>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuoteCurationWorkspaceQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getPreviewQuoteCurationUrl = (id: number) => {
  return `/api/admin/quotes/${id}/preview`;
};

export const previewQuoteCuration = async (
  id: number,
  quoteCurationInput: QuoteCurationInput,
  options?: RequestInit,
): Promise<QuoteCurationPreview> => {
  return customFetch<QuoteCurationPreview>(getPreviewQuoteCurationUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(quoteCurationInput),
  });
};

export const getPreviewQuoteCurationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewQuoteCuration>>,
    TError,
    { id: number; data: BodyType<QuoteCurationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewQuoteCuration>>,
  TError,
  { id: number; data: BodyType<QuoteCurationInput> },
  TContext
> => {
  const mutationKey = ["previewQuoteCuration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewQuoteCuration>>,
    { id: number; data: BodyType<QuoteCurationInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewQuoteCuration(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewQuoteCurationMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewQuoteCuration>>
>;
export type PreviewQuoteCurationMutationBody = BodyType<QuoteCurationInput>;
export type PreviewQuoteCurationMutationError = ErrorType<unknown>;

export const usePreviewQuoteCuration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewQuoteCuration>>,
    TError,
    { id: number; data: BodyType<QuoteCurationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewQuoteCuration>>,
  TError,
  { id: number; data: BodyType<QuoteCurationInput> },
  TContext
> => {
  return useMutation(getPreviewQuoteCurationMutationOptions(options));
};

export const getCurateQuoteUrl = (id: number) => {
  return `/api/admin/quotes/${id}/curate`;
};

export const curateQuote = async (
  id: number,
  quoteCurationInput: QuoteCurationInput,
  options?: RequestInit,
): Promise<QuoteCurationResult> => {
  return customFetch<QuoteCurationResult>(getCurateQuoteUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(quoteCurationInput),
  });
};

export const getCurateQuoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof curateQuote>>,
    TError,
    { id: number; data: BodyType<QuoteCurationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof curateQuote>>,
  TError,
  { id: number; data: BodyType<QuoteCurationInput> },
  TContext
> => {
  const mutationKey = ["curateQuote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof curateQuote>>,
    { id: number; data: BodyType<QuoteCurationInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return curateQuote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CurateQuoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof curateQuote>>
>;
export type CurateQuoteMutationBody = BodyType<QuoteCurationInput>;
export type CurateQuoteMutationError = ErrorType<unknown>;

export const useCurateQuote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof curateQuote>>,
    TError,
    { id: number; data: BodyType<QuoteCurationInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof curateQuote>>,
  TError,
  { id: number; data: BodyType<QuoteCurationInput> },
  TContext
> => {
  return useMutation(getCurateQuoteMutationOptions(options));
};

export const getSearchQuoteResolutionCandidatesUrl = (
  params?: SearchQuoteResolutionCandidatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/quotes/search?${stringifiedParams}`
    : `/api/admin/quotes/search`;
};

export const searchQuoteResolutionCandidates = async (
  params?: SearchQuoteResolutionCandidatesParams,
  options?: RequestInit,
): Promise<QuoteResolutionCandidate[]> => {
  return customFetch<QuoteResolutionCandidate[]>(
    getSearchQuoteResolutionCandidatesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchQuoteResolutionCandidatesQueryKey = (
  params?: SearchQuoteResolutionCandidatesParams,
) => {
  return [`/api/admin/quotes/search`, ...(params ? [params] : [])] as const;
};

export const getSearchQuoteResolutionCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchQuoteResolutionCandidates>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchQuoteResolutionCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchQuoteResolutionCandidates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchQuoteResolutionCandidatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchQuoteResolutionCandidates>>
  > = ({ signal }) =>
    searchQuoteResolutionCandidates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchQuoteResolutionCandidates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchQuoteResolutionCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchQuoteResolutionCandidates>>
>;
export type SearchQuoteResolutionCandidatesQueryError = ErrorType<unknown>;

export function useSearchQuoteResolutionCandidates<
  TData = Awaited<ReturnType<typeof searchQuoteResolutionCandidates>>,
  TError = ErrorType<unknown>,
>(
  params?: SearchQuoteResolutionCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchQuoteResolutionCandidates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchQuoteResolutionCandidatesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getRetryQuoteCurationUrl = (id: number) => {
  return `/api/admin/quotes/${id}/retry`;
};

export const retryQuoteCuration = async (
  id: number,
  quoteCurationRetryInput: QuoteCurationRetryInput,
  options?: RequestInit,
): Promise<QuoteCurationResult> => {
  return customFetch<QuoteCurationResult>(getRetryQuoteCurationUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(quoteCurationRetryInput),
  });
};

export const getRetryQuoteCurationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryQuoteCuration>>,
    TError,
    { id: number; data: BodyType<QuoteCurationRetryInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryQuoteCuration>>,
  TError,
  { id: number; data: BodyType<QuoteCurationRetryInput> },
  TContext
> => {
  const mutationKey = ["retryQuoteCuration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryQuoteCuration>>,
    { id: number; data: BodyType<QuoteCurationRetryInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return retryQuoteCuration(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryQuoteCurationMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryQuoteCuration>>
>;
export type RetryQuoteCurationMutationBody = BodyType<QuoteCurationRetryInput>;
export type RetryQuoteCurationMutationError = ErrorType<unknown>;

export const useRetryQuoteCuration = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryQuoteCuration>>,
    TError,
    { id: number; data: BodyType<QuoteCurationRetryInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryQuoteCuration>>,
  TError,
  { id: number; data: BodyType<QuoteCurationRetryInput> },
  TContext
> => {
  return useMutation(getRetryQuoteCurationMutationOptions(options));
};
